import clsx from "clsx";
import { observer } from "mobx-react-lite";
import Tooltip from "components/Tooltip";
import { dynamicTableStore } from "features/DynamicTable/DynamicTableStore";

const threeDecimalsFormatter = new Intl.NumberFormat("de-DE", {
  maximumFractionDigits: 3,
  minimumFractionDigits: 3,
});

function roundToThreeDecimals(input: string | number | null | undefined) {
  if (input === null || input === undefined) return "-";
  const num = Number(input);
  const roundedValue = threeDecimalsFormatter.format(num);
  const isRoundedToZero = parseFloat(num.toFixed(3)) === 0 && num !== 0;
  return `${isRoundedToZero ? "~" : ""}${roundedValue}`;
}

interface NumericCellProps {
  value: string | number | null;
  extraCssClasses?: string;
}

export default observer(function NumericCell({
  value,
  extraCssClasses,
}: NumericCellProps) {
  const rounded = roundToThreeDecimals(value);
  return (
    <Tooltip
      content={value}
      className={clsx(
        "text-right",
        dynamicTableStore.filterStore.hasGrouping()
          ? "!cursor-auto"
          : "cursor-pointer",
        extraCssClasses
      )}
      noFlex
      whiteTheme
    >
      {rounded ?? "-"}
    </Tooltip>
  );
});
